const RegisterFastIconFive = ({ width = 220, height = 214 }) => (
  <svg
    xmlns="http://www.w3.org/2000/svg"
    width={width}
    height={height}
    fill="none"
  >
    <path
      fill="#E0E0E0"
      d="M23.44 123.642a12.266 12.266 0 0 0 5.157 7.662 18.513 18.513 0 0 0 8.866 3.043c3.066.287 6.36-.063 8.808-1.931 2.447-1.868 3.645-5.576 1.971-8.16-2.367-3.657-7.45-3.966-11.794-3.651-4.343.315-8.91 1.582-13.008 3.037ZM62.425 100.943a12.266 12.266 0 0 1 4.493 8.069 18.442 18.442 0 0 1-1.313 9.284c-1.146 2.865-2.94 5.639-5.73 6.974-2.791 1.335-6.625.722-8.167-1.943-2.183-3.765-.149-8.441 2.092-12.172 2.24-3.73 5.467-7.22 8.625-10.212ZM14.918 104.049a11.737 11.737 0 0 0 3.358 8.161 17.715 17.715 0 0 0 7.713 4.539c2.814.859 5.966 1.146 8.596-.121 2.63-1.266 4.476-4.521 3.439-7.255-1.519-3.874-6.224-5.157-10.344-5.679-4.12-.521-8.648-.218-12.762.355ZM55.737 90.25a11.736 11.736 0 0 1 2.665 8.412 17.7 17.7 0 0 1-3.003 8.43c-1.61 2.464-3.834 4.717-6.682 5.439-2.848.722-6.338-.573-7.272-3.381-1.324-3.943 1.473-7.932 4.287-10.992 2.813-3.06 6.504-5.713 10.005-7.908ZM9.44 84.381a11.18 11.18 0 0 0 2.544 8.023 16.814 16.814 0 0 0 6.963 4.923c2.601 1.037 5.575 1.57 8.189.573 2.613-.997 4.584-3.937 3.81-6.625-1.146-3.793-5.5-5.364-9.37-6.206-3.867-.842-8.183-.905-12.137-.688ZM49.296 74.536a11.158 11.158 0 0 1 1.857 8.2 16.831 16.831 0 0 1-3.501 7.766c-1.72 2.212-4.012 4.177-6.774 4.636-2.762.458-5.971-1.072-6.636-3.788-.946-3.845 2.028-7.416 4.94-10.092a46.421 46.421 0 0 1 10.114-6.722ZM8.339 65.854a10.596 10.596 0 0 0 1.433 7.857 16.046 16.046 0 0 0 5.977 5.484c2.326 1.29 5.066 2.15 7.65 1.519 2.585-.63 4.82-3.158 4.39-5.788-.613-3.714-4.539-5.73-8.086-6.98a44.196 44.196 0 0 0-11.364-2.092ZM47.078 61.355a10.642 10.642 0 0 1 .768 7.955 15.982 15.982 0 0 1-4.206 6.905c-1.891 1.88-4.287 3.438-6.946 3.553-2.659.115-5.501-1.72-5.805-4.373-.424-3.736 2.808-6.739 5.874-8.916a44.3 44.3 0 0 1 10.315-5.124ZM11.33 45.401a10.069 10.069 0 0 0 .218 7.57 15.13 15.13 0 0 0 4.82 5.99c2 1.54 4.44 2.738 6.956 2.515 2.516-.224 4.963-2.292 4.934-4.797-.04-3.57-3.438-6.011-6.584-7.696A42.033 42.033 0 0 0 11.33 45.4ZM48.3 46.742c.852 2.48.704 5.193-.413 7.565a15.174 15.174 0 0 1-4.974 5.862c-2.035 1.49-4.505 2.625-7.015 2.339-2.51-.287-4.905-2.396-4.814-4.917.132-3.57 3.594-5.926 6.78-7.525a41.904 41.904 0 0 1 10.435-3.324ZM17.382 26.685a9.502 9.502 0 0 0-.756 7.118 14.327 14.327 0 0 0 3.748 6.223c1.673 1.72 3.805 3.135 6.189 3.244 2.384.108 4.94-1.49 5.238-3.857.412-3.347-2.453-6.069-5.158-8.023a39.465 39.465 0 0 0-9.26-4.705ZM51.834 32.662a9.513 9.513 0 0 1-1.358 7.031 14.28 14.28 0 0 1-5.404 4.854c-2.097 1.147-4.584 1.886-6.877 1.295-2.292-.59-4.292-2.865-3.88-5.226.574-3.318 4.121-5.083 7.307-6.178a39.63 39.63 0 0 1 10.212-1.776ZM39.531 17.716a1.054 1.054 0 0 0-1.421-.378 13.949 13.949 0 0 0-5.834 5.668 7.81 7.81 0 0 0-.785 5.524c.923 3.817 5.989 5.026 8.47 1.977 1.914-2.355 2.2-5.616 1.776-8.596-.235-1.616-1.37-2.808-2.206-4.195Z"
    />
    <path
      fill="#E0E0E0"
      d="M92.752 146.038c-13.347-1.301-26.19-7.118-37.204-16.774a79.083 79.083 0 0 1-22.762-34.619c-6.728-20.928-5.232-45.238 4.218-68.447l1.06.435c-9.324 22.94-10.831 46.969-4.166 67.674 8.762 27.249 33.014 48.069 58.98 50.619l-.126 1.112ZM197.71 123.642a12.262 12.262 0 0 1-5.158 7.662 18.558 18.558 0 0 1-8.871 3.043c-3.06.287-6.361-.063-8.808-1.931s-3.645-5.576-1.972-8.16c2.367-3.657 7.45-3.966 11.8-3.651 4.349.315 8.911 1.582 13.009 3.037ZM158.724 100.943a12.268 12.268 0 0 0-4.481 8.069 18.506 18.506 0 0 0 1.312 9.284c1.146 2.865 2.94 5.639 5.731 6.974s6.624.722 8.166-1.943c2.183-3.765.155-8.441-2.092-12.172-2.246-3.73-5.478-7.22-8.636-10.212ZM206.231 104.049a11.737 11.737 0 0 1-3.358 8.161 17.67 17.67 0 0 1-7.714 4.539c-2.813.859-5.965 1.146-8.596-.121-2.63-1.266-4.475-4.521-3.404-7.255 1.513-3.874 6.218-5.157 10.316-5.679 4.097-.521 8.642-.218 12.756.355ZM165.411 90.25a11.712 11.712 0 0 0-2.659 8.412 17.584 17.584 0 0 0 3.003 8.43c1.605 2.464 3.828 4.717 6.676 5.439 2.849.722 6.339-.573 7.273-3.381 1.323-3.943-1.473-7.932-4.287-10.992-2.814-3.06-6.481-5.713-10.006-7.908ZM211.71 84.381a11.181 11.181 0 0 1-2.545 8.023 16.808 16.808 0 0 1-6.963 4.923c-2.601 1.037-5.57 1.57-8.189.573-2.619-.997-4.584-3.937-3.805-6.625 1.146-3.793 5.496-5.364 9.364-6.206 3.868-.842 8.184-.905 12.138-.688ZM171.858 74.536a11.138 11.138 0 0 0-1.862 8.2 16.829 16.829 0 0 0 3.519 7.766c1.719 2.212 4.011 4.177 6.779 4.636 2.768.458 5.966-1.072 6.636-3.788.94-3.845-2.029-7.416-4.945-10.092a46.516 46.516 0 0 0-10.127-6.722ZM212.81 65.854a10.598 10.598 0 0 1-1.433 7.857 16.05 16.05 0 0 1-5.977 5.484c-2.327 1.29-5.06 2.15-7.651 1.519-2.59-.63-4.819-3.158-4.389-5.788.613-3.714 4.538-5.73 8.092-6.98a44.12 44.12 0 0 1 11.358-2.092ZM174.047 61.355a10.645 10.645 0 0 0-.768 7.955 16.055 16.055 0 0 0 4.258 6.905c1.886 1.88 4.281 3.438 6.94 3.553 2.659.115 5.502-1.72 5.805-4.373.424-3.736-2.802-6.739-5.874-8.916a44.293 44.293 0 0 0-10.361-5.124ZM209.83 45.401a10.066 10.066 0 0 1-.223 7.57 15.132 15.132 0 0 1-4.82 5.99c-2 1.54-4.441 2.738-6.951 2.515-2.51-.224-4.969-2.292-4.94-4.797.04-3.57 3.438-6.011 6.585-7.696A42.017 42.017 0 0 1 209.83 45.4ZM172.85 46.742a10.071 10.071 0 0 0 .413 7.565 15.17 15.17 0 0 0 4.974 5.862c2.034 1.49 4.504 2.625 7.014 2.339 2.51-.287 4.906-2.396 4.814-4.917-.132-3.57-3.587-5.926-6.779-7.525a41.903 41.903 0 0 0-10.436-3.324ZM203.767 26.685a9.5 9.5 0 0 1 .757 7.118 14.254 14.254 0 0 1-3.748 6.223c-1.673 1.72-3.805 3.135-6.189 3.244-2.384.108-4.94-1.49-5.238-3.857-.413-3.347 2.453-6.069 5.186-8.023a39.425 39.425 0 0 1 9.232-4.705ZM169.314 32.662a9.512 9.512 0 0 0 1.359 7.031 14.271 14.271 0 0 0 5.404 4.854c2.097 1.147 4.555 1.886 6.876 1.295 2.321-.59 4.293-2.865 3.88-5.226-.573-3.318-4.115-5.083-7.307-6.178a39.625 39.625 0 0 0-10.212-1.776ZM181.618 17.716a1.059 1.059 0 0 1 1.427-.378 13.966 13.966 0 0 1 5.828 5.668 7.808 7.808 0 0 1 .785 5.524c-.923 3.817-5.988 5.026-8.47 1.977-1.914-2.355-2.2-5.616-1.771-8.596.23-1.616 1.364-2.808 2.201-4.195Z"
    />
    <path
      fill="#E0E0E0"
      d="m128.396 146.038-.108-1.146c25.954-2.544 50.223-23.364 58.98-50.585 6.647-20.676 5.157-44.7-4.184-67.662l1.066-.436c9.445 23.21 10.94 47.52 4.212 68.448a79.037 79.037 0 0 1-22.756 34.607c-10.997 9.657-23.863 15.473-37.21 16.774ZM93.709 133.683l-3.439 18.069h4.298l6.023-14.413s-.43-4.516-6.882-3.656Z"
    />
    <path
      fill="#E0E0E0"
      d="m131.32 133.683 3.438 18.069h-4.298l-6.017-14.413s.435-4.516 6.877-3.656Z"
    />
    <path
      fill="#EBEBEB"
      d="M143.863 118.597c4.092-17.336-6.645-34.706-23.981-38.798-17.336-4.092-34.707 6.645-38.799 23.981-4.091 17.336 6.645 34.707 23.982 38.799 17.336 4.091 34.707-6.645 38.798-23.982Z"
    />
    <path
      fill="#fff"
      d="M112.89 136.118c13.765 0 24.923-11.158 24.923-24.923 0-13.764-11.158-24.922-24.923-24.922-13.764 0-24.923 11.158-24.923 24.922 0 13.765 11.159 24.923 24.923 24.923Z"
    />
    <path
      fill="#E6E6E6"
      d="M131.961 115.788c2.54-10.763-4.125-21.547-14.888-24.087-10.763-2.54-21.547 4.125-24.087 14.888-2.54 10.763 4.125 21.547 14.888 24.087 10.763 2.54 21.547-4.125 24.087-14.888Z"
    />
    <path
      fill="#fff"
      d="M112.477 126.668c8.545 0 15.473-6.927 15.473-15.472 0-8.546-6.928-15.473-15.473-15.473-8.546 0-15.473 6.927-15.473 15.473 0 8.545 6.927 15.472 15.473 15.472Z"
    />
    <path
      fill="#E0E0E0"
      d="M112.477 115.665a4.47 4.47 0 1 0 0-8.94 4.47 4.47 0 0 0 0 8.94Z"
    />
    <path
      fill="#E6E6E6"
      d="m152.117 118.926-6.705 2.86-11.714-3.542-.006-.005 4.654-3.588 13.771 4.275Z"
    />
    <path
      fill="#000"
      d="m152.117 118.926-6.705 2.86-11.714-3.542-.006-.005 4.654-3.588 13.771 4.275Z"
      opacity={0.1}
    />
    <path
      fill="#E0E0E0"
      d="M112.047 111.281a.536.536 0 0 1 .676-.355l32.843 10.344-.309 1.031-32.849-10.349a.573.573 0 0 1-.361-.671Z"
    />
    <path
      fill="#000"
      d="M112.047 111.281a.555.555 0 0 1 .264-.318.535.535 0 0 1 .412-.037l32.843 10.344-.31 1.032-32.848-10.35a.57.57 0 0 1-.361-.671Z"
      opacity={0.1}
    />
    <path
      fill="#E6E6E6"
      d="m147.841 127.808-11.565-3.518-2.578-6.046 11.713 3.541 2.43 6.023Z"
    />
    <path
      fill="#000"
      d="m147.841 127.808-11.565-3.518-2.579-6.046 11.714 3.541 2.43 6.023Z"
      opacity={0.1}
    />
    <path
      fill="#EBEBEB"
      d="M70.935 69.963a2.006 2.006 0 0 0 2.659.573l14.252-8.464c.31-.184.665-.28 1.026-.281l33.61.074 16.092-10.653 1.502 2.034 3.719-7.942-8.212.664.945 1.914-14.412 10.264-33.703.052c-.332 0-.66.085-.95.246L71.616 67.04a2.008 2.008 0 0 0-.682 2.923ZM149.623 36.628h-1.719a1.576 1.576 0 0 0-1.553 1.472l-.412 7.955a1.376 1.376 0 0 0 .376 1.044 1.382 1.382 0 0 0 1.022.434h1.719a1.576 1.576 0 0 0 1.553-1.478l.418-7.955a1.375 1.375 0 0 0-.38-1.043 1.39 1.39 0 0 0-1.024-.43ZM163.245 36.627h-5.049l1.146-2.653a1.8 1.8 0 0 0 .132-.9l-.235-2.091a1.644 1.644 0 0 0-1.656-1.467h-2.006l-.172 3.238-3.249 4.097a2.51 2.51 0 0 0-.544 1.421l-.39 7.45a1.722 1.722 0 0 0 1.037 1.682c.215.093.448.14.682.14h7.032a2.237 2.237 0 0 0 1.65-.75l.654-.728a2.29 2.29 0 0 0 .561-1.043l1.547-6.877-1.14-1.519Z"
    />
    <path
      fill="#01A76A"
      d="M111.636 172.106h-10.023l-1.576-33.886h13.175l-1.576 33.886Z"
    />
    <path
      fill="#000"
      d="M112.702 149.172a9.844 9.844 0 0 1-12.155 0l-.516-10.946h13.181l-.51 10.946Z"
      opacity={0.2}
    />
    <path
      fill="#01A76A"
      d="M77.109 121.051c-13.909 0-27.135-10.407-30.774-24.206l-6.476-24.602a14.053 14.053 0 0 1 2.235-12.292 13.502 13.502 0 0 1 10.848-5.158h19.811a4.768 4.768 0 0 1 0 9.53H52.948a3.967 3.967 0 0 0-3.3 1.433 4.584 4.584 0 0 0-.574 4.046l6.487 24.607c2.527 9.588 12 17.101 21.559 17.101a4.769 4.769 0 1 1 0 9.53l-.011.011ZM136.135 121.051a4.773 4.773 0 0 1-4.933-4.765 4.77 4.77 0 0 1 4.933-4.765c9.559 0 19.031-7.513 21.559-17.1l6.481-24.608a4.575 4.575 0 0 0-.573-4.046 3.962 3.962 0 0 0-3.301-1.433h-19.805a4.77 4.77 0 1 1 0-9.53h19.805a13.506 13.506 0 0 1 10.848 5.158 14.047 14.047 0 0 1 2.235 12.292l-6.481 24.602c-3.639 13.788-16.871 24.195-30.768 24.195Z"
    />
    <g fill="#000" opacity={0.2}>
      <path d="M77.515 59.572a4.768 4.768 0 0 0-4.762-4.768H56.174l1.146 9.53h15.433a4.762 4.762 0 0 0 4.762-4.762ZM77.108 111.521c-5.392 0-10.75-2.384-14.86-6.189l.671 5.553a42.59 42.59 0 0 0 1.53 7.29 30.103 30.103 0 0 0 12.66 2.865 4.78 4.78 0 0 0 3.477-1.336 4.772 4.772 0 0 0 1.455-3.429 4.77 4.77 0 0 0-4.933-4.765v.011ZM131.361 116.289a4.766 4.766 0 0 0 4.762 4.762c4.38-.023 8.702-1 12.665-2.865a42.58 42.58 0 0 0 1.53-7.29l.664-5.553c-4.103 3.805-9.461 6.189-14.859 6.189a4.77 4.77 0 0 0-4.762 4.757ZM140.496 54.804a4.767 4.767 0 0 0 0 9.53h15.427l1.146-9.53h-16.573Z" />
    </g>
    <path
      fill="#01A76A"
      d="M102.415 42.506h-4.057v.573h4.057v-.573ZM94.828 42.506H80.26v.573h14.568v-.573ZM106.622 144.696a39.72 39.72 0 0 1-39.588-36.482l-4.98-60.94a2.55 2.55 0 0 1 2.544-2.762h84.052a2.555 2.555 0 0 1 2.545 2.762l-4.98 60.94a39.726 39.726 0 0 1-39.593 36.482Z"
    />
    <path
      fill="#fff"
      d="M93.79 133.699a.996.996 0 0 1-.409 1.675 1 1 0 0 1-.679-.042 33.389 33.389 0 0 1-19.335-27.616L68.85 52.529a1.517 1.517 0 0 1 1.507-1.639h6.848a1.507 1.507 0 0 1 1.507 1.399l4.396 57.88a36.927 36.927 0 0 0 10.642 23.495l.04.035Z"
      opacity={0.1}
    />
    <path
      fill="#01A76A"
      d="M127.034 184.186h-40.82a1.752 1.752 0 0 1-1.719-2.074l1.278-6.791a7.069 7.069 0 0 1 6.94-5.759h27.823a7.065 7.065 0 0 1 6.939 5.759l1.278 6.791a1.76 1.76 0 0 1-.373 1.44 1.755 1.755 0 0 1-1.346.634Z"
    />
    <path
      fill="#000"
      d="M128.753 182.112H84.495a1.75 1.75 0 0 0 .976 1.907c.233.109.486.167.743.167h40.82a1.75 1.75 0 0 0 1.693-1.313 1.76 1.76 0 0 0 .026-.761Z"
      opacity={0.2}
    />
    <path
      fill="#01A76A"
      d="M139.631 184.186H73.613c-.962 0-1.742.78-1.742 1.742v25.536c0 .963.78 1.742 1.742 1.742h66.018c.962 0 1.742-.779 1.742-1.742v-25.536c0-.962-.78-1.742-1.742-1.742Z"
    />
    <path
      fill="#fff"
      d="M139.631 184.186H73.613c-.962 0-1.742.78-1.742 1.742v25.536c0 .963.78 1.742 1.742 1.742h66.018c.962 0 1.742-.779 1.742-1.742v-25.536c0-.962-.78-1.742-1.742-1.742Z"
      opacity={0.7}
    />
    <path
      fill="url(#a)"
      d="M44.855 81.748c-3.867 0-5.686-3.89-5.762-4.054a.772.772 0 0 1 1.398-.643c0 .052 1.539 3.24 4.48 3.159a.772.772 0 0 1 .042 1.538h-.158Z"
    />
    <path
      fill="url(#b)"
      d="M95.39 27.727a7.392 7.392 0 0 1-1.006-.065.769.769 0 0 1 .228-1.52c.035 0 3.556.497 5.1-2.013a.77.77 0 0 1 1.056-.254.766.766 0 0 1 .255 1.055c-1.538 2.434-4.2 2.797-5.633 2.797Z"
    />
    <path
      fill="#fff"
      d="M95.39 27.727a7.392 7.392 0 0 1-1.006-.065.769.769 0 0 1 .228-1.52c.035 0 3.556.497 5.1-2.013a.77.77 0 0 1 1.056-.254.766.766 0 0 1 .255 1.055c-1.538 2.434-4.2 2.797-5.633 2.797Z"
      opacity={0.6}
    />
    <path
      fill="url(#c)"
      d="M8.581 57.022a8.061 8.061 0 0 1-4.165-1.328.767.767 0 1 1 .89-1.246c.029 0 2.977 1.995 5.463.41a.773.773 0 1 1 .83 1.298 5.523 5.523 0 0 1-3.018.866Z"
    />
    <path
      fill="#fff"
      d="M8.581 57.022a8.061 8.061 0 0 1-4.165-1.328.767.767 0 1 1 .89-1.246c.029 0 2.977 1.995 5.463.41a.773.773 0 1 1 .83 1.298 5.523 5.523 0 0 1-3.018.866Z"
      opacity={0.6}
    />
    <path
      fill="url(#d)"
      d="M209.24 36.508a8.115 8.115 0 0 1-4.171-1.287.77.77 0 0 1-.196-1.068.77.77 0 0 1 1.068-.196c.029 0 2.983 1.989 5.469.41a.772.772 0 0 1 .852.018.772.772 0 0 1 .309.793.749.749 0 0 1-.336.481 5.466 5.466 0 0 1-2.995.849Z"
    />
    <path
      fill="#fff"
      d="M209.24 36.508a8.115 8.115 0 0 1-4.171-1.287.77.77 0 0 1-.196-1.068.77.77 0 0 1 1.068-.196c.029 0 2.983 1.989 5.469.41a.772.772 0 0 1 .852.018.772.772 0 0 1 .309.793.749.749 0 0 1-.336.481 5.466 5.466 0 0 1-2.995.849Z"
      opacity={0.6}
    />
    <path
      fill="url(#e)"
      d="M115.167 96.928c-3.586 0-5.539-3.475-5.627-3.633a.768.768 0 1 1 1.345-.743c0 .047 1.755 3.112 4.68 2.814a.774.774 0 0 1 .795.692.774.774 0 0 1-.637.84c-.176.018-.369.03-.556.03Z"
    />
    <path
      fill="#fff"
      d="M115.167 96.928c-3.586 0-5.539-3.475-5.627-3.633a.768.768 0 1 1 1.345-.743c0 .047 1.755 3.112 4.68 2.814a.774.774 0 0 1 .795.692.774.774 0 0 1-.637.84c-.176.018-.369.03-.556.03Z"
      opacity={0.6}
    />
    <path
      fill="url(#f)"
      d="M17.005 112.552a.77.77 0 0 1-.754-.675.765.765 0 0 1 .573-.834c.035 0 3.468-.907 3.936-3.82a.767.767 0 1 1 1.515.246c-.625 3.925-4.901 5.019-5.083 5.065a.98.98 0 0 1-.187.018Z"
    />
    <path
      fill="#000"
      d="M17.005 112.552a.77.77 0 0 1-.754-.675.765.765 0 0 1 .573-.834c.035 0 3.468-.907 3.936-3.82a.767.767 0 1 1 1.515.246c-.625 3.925-4.901 5.019-5.083 5.065a.98.98 0 0 1-.187.018Z"
      opacity={0.6}
    />
    <path
      fill="url(#g)"
      d="M187.814 59.233a.765.765 0 0 1-.651-1.21.765.765 0 0 1 .464-.305c.035 0 3.468-.9 3.936-3.814a.776.776 0 0 1 .578-.678.772.772 0 0 1 .943.924c-.632 3.925-4.908 5.02-5.089 5.06a.64.64 0 0 1-.181.023Z"
    />
    <path
      fill="#000"
      d="M187.814 59.233a.765.765 0 0 1-.651-1.21.765.765 0 0 1 .464-.305c.035 0 3.468-.9 3.936-3.814a.776.776 0 0 1 .578-.678.772.772 0 0 1 .943.924c-.632 3.925-4.908 5.02-5.089 5.06a.64.64 0 0 1-.181.023Z"
      opacity={0.6}
    />
    <path
      fill="url(#h)"
      d="M219.243 88.4h-.129c-.187-.036-4.528-.831-5.423-4.68a.77.77 0 0 1 .887-.932.775.775 0 0 1 .623.593c.666 2.866 4.153 3.51 4.188 3.51a.774.774 0 0 1 .37 1.315.772.772 0 0 1-.505.211l-.011-.017Z"
    />
    <path
      fill="url(#i)"
      d="M205.531 116.6a5.617 5.617 0 0 1-3.674-1.292.767.767 0 1 1 .983-1.17c2.264 1.883 5.44.304 5.475.286a.768.768 0 0 1 1.083.92.763.763 0 0 1-.381.449 8.315 8.315 0 0 1-3.486.807Z"
    />
    <path
      fill="url(#j)"
      d="M169.679 20.596a.754.754 0 0 1-.38-.099c-.158-.088-3.978-2.299-3.51-6.247a.766.766 0 0 1 .851-.676.766.766 0 0 1 .676.851c-.333 2.925 2.732 4.72 2.761 4.738a.769.769 0 0 1 .361.872.764.764 0 0 1-.759.561Z"
    />
    <path
      fill="url(#k)"
      d="M16.881 23.714a.768.768 0 0 1-.064-1.532c2.925-.258 4.095-3.615 4.095-3.65a.766.766 0 0 1 1.456.474c-.052.18-1.456 4.363-5.416 4.68l-.07.028Z"
    />
    <defs>
      <linearGradient
        id="a"
        x1={42.718}
        x2={45.356}
        y1={79.712}
        y2={79.712}
        gradientUnits="userSpaceOnUse"
      >
        <stop stopColor="#00CF83" />
        <stop offset={1} stopColor="#00FF5E" />
      </linearGradient>
      <linearGradient
        id="b"
        x1={97.816}
        x2={100.752}
        y1={26.141}
        y2={26.141}
        gradientUnits="userSpaceOnUse"
      >
        <stop stopColor="#00CF83" />
        <stop offset={1} stopColor="#00FF5E" />
      </linearGradient>
      <linearGradient
        id="c"
        x1={8.44}
        x2={11.585}
        y1={55.926}
        y2={55.926}
        gradientUnits="userSpaceOnUse"
      >
        <stop stopColor="#00CF83" />
        <stop offset={1} stopColor="#00FF5E" />
      </linearGradient>
      <linearGradient
        id="d"
        x1={209.07}
        x2={212.183}
        y1={35.433}
        y2={35.433}
        gradientUnits="userSpaceOnUse"
      >
        <stop stopColor="#00CF83" />
        <stop offset={1} stopColor="#00FF5E" />
      </linearGradient>
      <linearGradient
        id="e"
        x1={113.262}
        x2={116.006}
        y1={95.019}
        y2={95.019}
        gradientUnits="userSpaceOnUse"
      >
        <stop stopColor="#00CF83" />
        <stop offset={1} stopColor="#00FF5E" />
      </linearGradient>
      <linearGradient
        id="f"
        x1={19.578}
        x2={21.973}
        y1={110.163}
        y2={110.163}
        gradientUnits="userSpaceOnUse"
      >
        <stop stopColor="#00CF83" />
        <stop offset={1} stopColor="#00FF5E" />
      </linearGradient>
      <linearGradient
        id="g"
        x1={190.378}
        x2={192.79}
        y1={56.821}
        y2={56.821}
        gradientUnits="userSpaceOnUse"
      >
        <stop stopColor="#00CF83" />
        <stop offset={1} stopColor="#00FF5E" />
      </linearGradient>
      <linearGradient
        id="h"
        x1={217.163}
        x2={219.672}
        y1={86.161}
        y2={86.161}
        gradientUnits="userSpaceOnUse"
      >
        <stop stopColor="#00CF83" />
        <stop offset={1} stopColor="#00FF5E" />
      </linearGradient>
      <linearGradient
        id="i"
        x1={205.895}
        x2={209.026}
        y1={115.528}
        y2={115.528}
        gradientUnits="userSpaceOnUse"
      >
        <stop stopColor="#00CF83" />
        <stop offset={1} stopColor="#00FF5E" />
      </linearGradient>
      <linearGradient
        id="j"
        x1={168.352}
        x2={170.222}
        y1={17.786}
        y2={17.786}
        gradientUnits="userSpaceOnUse"
      >
        <stop stopColor="#00CF83" />
        <stop offset={1} stopColor="#00FF5E" />
      </linearGradient>
      <linearGradient
        id="k"
        x1={19.567}
        x2={22.071}
        y1={21.44}
        y2={21.44}
        gradientUnits="userSpaceOnUse"
      >
        <stop stopColor="#00CF83" />
        <stop offset={1} stopColor="#00FF5E" />
      </linearGradient>
    </defs>
  </svg>
)
export default RegisterFastIconFive
